<template>
  <div v-if="state" class="messageBoxIndex" @click.stop="MessageBox">
    <div id="messageBoxPosition" v-loading="loading" class="messageBoxPosition" :style="{'top':messageBoxTop,'width':'566px','height':'265px'}">
      <dropDownBox width="566" height="265">
        <div slot="body">
          <el-tabs v-model="tabsName" tab-position="left" style="height: 200px;" class="notice" @tab-click="tabClick">
            <el-tab-pane v-for="(value,index) in typeList" :key="index" :label="value.type" :name="value.type">
              <span slot="label">
                <div :class="value[value.content]>0?'systemNotification':''" :data-content-after="value[value.content]">{{ value.type }}</div>
              </span>
              <el-scrollbar style="height: 100%" :native="false" :noresize="false" tag="section">
                <el-form v-if="value.usertable.length>0" ref="ruleForm" label-width="88px" class="demo-ruleForm">
                  <div v-for="(val,i) in value.usertable" :key="i">
                    <div v-if="val.contentJson" class="ruleFormTitle">{{ val.title }}</div>
                    <el-form-item v-if="val.contentJson && val.contentJson.location && val.contentJson.username" label="所属房屋：" prop="pass">
                      <div>{{ `${val.contentJson.location}` }}</div>
                    </el-form-item>
                    <el-form-item v-if="val.contentJson && val.contentJson.username" label="住户姓名：" prop="checkPass">
                      <div>{{ `${val.contentJson.username}` }}</div>
                    </el-form-item>
                    <el-form-item v-if="val.contentJson && val.contentJson.typeName" label="设备名称：" prop="pass">
                      <div>{{ `${val.contentJson.typeName}` }}</div>
                    </el-form-item>
                    <el-form-item v-if="val.contentJson && val.contentJson.location && val.contentJson.typeName" label="安装位置：" prop="checkPass">
                      <div>{{ `${val.contentJson.location}` }}</div>
                    </el-form-item>
                    <el-form-item v-if="val.contentJson && val.contentJson.plateNumber" label="车牌号：" prop="age">
                      <div>{{ `${val.contentJson.plateNumber}` }}</div>
                    </el-form-item>
                    <el-form-item v-if="val.contentJson && val.contentJson.notificationTime" label="通知时间：" prop="age">
                      <div>{{ `${val.contentJson.notificationTime}` }}</div>
                    </el-form-item>
                    <el-button v-if="val.contentJson" class="detail" type="text" @click="checkTheDetails(val)">查看详情</el-button>
                  </div>
                </el-form>
                <div v-else>
                  <el-empty :image-size="70" description="暂无新系统通知消息" />
                </div>
              </el-scrollbar>
            </el-tab-pane>
          </el-tabs>
          <div class="seeMore">
            <el-button type="text" @click="haveRead(tabsName)">全部标记已读</el-button>
            <div style="flex:1" />
            <el-button type="text" @click="checkTheDetails">查看更多<i class="el-icon-arrow-right el-icon--right" /></el-button>
          </div>
        </div>
      </dropDownBox>
    </div>
  </div>
</template>

<script>
import dropDownBox from '../dropDownBox'
import {
  getNotification,
  getNotificationId,
  putNotificationTypeIsRead
} from '@/api/message.js'
export default {
  name: 'MessageBoxIndex',
  components: {
    dropDownBox
  },
  props: {
    messageBoxLeft: {
      type: String,
      default: '25%'
    },
    messageBoxTop: {
      type: String,
      default: '55px'
    },
    customerType: {
      type: Array,
      default: () => []
    }
  },
  inject: ['reload'],
  data() {
    return {
      state: false,
      dataLeft: '',
      totalWidth: document.documentElement.clientWidth,
      formInline: {
        orgId: this.$store.state.user.organizationId,
        page: 0,
        size: 10,
        isRead: false,
        typeList: ['系统通知'],
        userId: this.$store.state.user.user.id,
        sort: `updateTime,desc`
      },
      usertable: [],
      typeList: {
        '系统通知': {
          type: '系统通知',
          content: 'systemNotification',
          systemNotification: '',
          usertable: []
        }, '服务提醒': {
          type: '服务提醒',
          content: 'serviceReminder',
          serviceReminder: '',
          usertable: []
        }
      },
      tabsName: '系统通知',
      loading: false

    }
  },
  computed: {

  },
  watch: {
    state() {
      if (this.state) {
        this.loading = true
        for (const key in this.typeList) {
          if (Object.hasOwnProperty.call(this.typeList, key)) {
            const element = this.typeList[key]
            this.formInline.typeList = [element.type]
            this.submitForm((i, content) => {
              this.typeList[element.type][this.typeList[element.type].content] = i
              this.typeList[element.type].usertable = content
              this.$forceUpdate()
            })
          }
        }
      } else {
        this.formInline.typeList = []
      }
    }
  },
  mounted() {
    document.body.appendChild(this.$el)
    this.formInline.typeList = []
  },

  methods: {
    haveRead(type) {
      // this.$emit('messageContent', 112)
      putNotificationTypeIsRead({ type, userId: this.$store.state.user.user.id }).then(() => {}).finally(() => {
        this.tabClick({ 'label': type })
        this.formInline.typeList = []
        this.submitForm((i, content) => {
          this.$emit('messageContent', i)
        })
      })
    },
    tabClick(event) {
      // console.log(event)
      switch (event.label) {
        case '系统通知':
          this.formInline.typeList = ['系统通知']
          break
        case '服务提醒':
          this.formInline.typeList = ['服务提醒']
          break
        default:
          this.formInline.typeList = []
          break
      }
      this.submitForm((i, content) => {
        this.typeList[event.label].usertable = content
        this.typeList[event.label][this.typeList[event.label].content] = i
      })
    },
    // 重置
    repossess() {
      this.formInline = {
        orgId: this.$store.state.user.organizationId,
        page: 0,
        size: 10,
        isRead: false,
        userId: this.$store.state.user.user.id,
        typeList: ['系统通知'],
        sort: `timestamp,desc`
      }
      this.submitForm()
    },
    MessageBox(event) {
      if (event.currentTarget === event.target) {
        this.state = false
      }
    },
    submitForm(cd) {
      getNotification(this.formInline).then((result) => {
        // console.log(this.formInline)
        // debugger
        result.content.forEach(element => {
          if (element.contentJson) {
            element.contentJson = JSON.parse(element.contentJson)
          }
        })
        // if (this.formInline.typeList.length > 0) {
        //   this.typeList[this.formInline.typeList[0]].usertable = result.content
        //   // console.log(this.typeList)
        // }

        // console.log(this.typeList[this.formInline.typeList].usertable)
        return cd(result.totalElements, result.content)
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    checkTheDetails(row) {
      console.log(row.subType)
      if (!row.subType) {
        this.jump('messageNotification', {})
        this.state = false
        return
      }
      switch (row.subType) {
        // case '故障消息通知':
        case '非住户人脸上传失败':// 非住户管理	编辑
          this.jump('Household', row)
          this.state = false
          break
        case '住户迁出通知': // 住户管理	详情
        case '住户人脸上传失败':// 住户管理	编辑
          this.jump('Household', row)
          this.state = false
          break
        case '业主认证房屋审核通知': // 审核
        case '租客认证房屋审核-物业审核通知': // 审核
        case '人脸通行审核通知':// 审核
        case '车辆审核通知':// 审核
          this.jump('auditList', row)
          this.state = false
          break
        case '告警消息通知':// 消息通知	详情
          this.jump('messageNotification', row)
          this.state = false
          break
        default:
          break
      }
      // // 跳转审核
      // if (row.subType.includes('审核')) {
      //   this.jump('auditList', row)
      //   this.state = false
      // }
      // // 跳转住户详情
      // if (row.subType.includes('迁出') || row.subType.includes('人脸上传失败')) {
      //   this.jump('Household', row)
      //   this.state = false
      // }
      // // 跳转消息详情
      // if (row.subType.includes('消息')) {
      //   this.jump('messageNotification', row)
      //   this.state = false
      // }
      console.log(row.businessId)
      getNotificationId(row.businessId)
      this.formInline.typeList = []
      this.submitForm((i, content) => {
        this.$emit('messageContent', i)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    jump(name, row) {
      const view = this.$store.state.tagsView.visitedViews.filter((value) => {
        return value.name === name
      })[0]
      if (view && window.location.pathname === view.path) {
        if (this.isActive(view)) {
          this.$store.dispatch('tagsView/delCachedView', view).then(() => {
            const { fullPath } = view
            this.$nextTick(() => {
              if (name === 'Household') {
                console.log(row.contentJson)
                console.log({ identityId: row.businessId,
                  userId: row.contentJson.userId,
                  orgId: row.orgId,
                  assetId: row.contentJson.assetId,
                  interfaceStyle: row.contentJson.interfaceStyle })
                this.$router.replace({
                  path: '/redirect' + fullPath, query: {
                    id: row.businessId,
                    userId: row.contentJson.userId,
                    orgId: row.orgId,
                    assetId: row.contentJson.assetId,
                    interfaceStyle: row.contentJson.interfaceStyle }})
              } else {
                this.$router.replace({ path: '/redirect' + fullPath, query: { id: row.businessId }})
              }
            })
          })
        }
      } else {
        if (name === 'Household') {
          this.$router.replace({ name: name, params: {
            id: row.businessId,
            userId: row.contentJson.userId,
            orgId: row.orgId,
            assetId: row.contentJson.assetId,
            interfaceStyle: row.contentJson.interfaceStyle }})
        } else {
          this.$router.replace({ name: name, params: { id: row.businessId }})
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.messageBoxIndex{
    width: 100%;
    height: 100%;
    // background-color: aqua;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10000;
    .messageBoxPosition{
      position: absolute;
      right: 23px;
      .notice{
        padding: 0 13px 16px 0;
        margin-top: 30px;
        border-bottom: 1px solid rgba(196, 196, 196, 0.5);
        margin-left: 6px;
        margin-right: 6px;
        .el-tab-pane{
          // overflow: hidden;
          height: 190px;
          /* element滚动条组件 隐藏水平滚动条 */
          ::v-deep{
            .el-scrollbar__wrap {
              overflow-x: hidden;
            }
            .is-horizontal {
              display: none;
            }
          }
        }
      }
      .seeMore{
        display:flex;
        // flex-direction:row-reverse;
        margin: 0 6px;
        .el-button{
          font-size: 16px;
        }
      }
    }
}
.ruleFormTitle{
  font-size: 16px;
  margin-bottom: 15px;
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow:ellipsis;
}
.el-form-item--small.el-form-item {
  margin-bottom: 8px;
}
.detail{
  margin-left: 5px;
  margin-bottom: 12px;
  font-size: 16px;
}
.demo-ruleForm{
  ::v-deep{
    .el-form-item__label{
      font-size: 14px;
      color: #000;
    }
    .el-form-item__content{
      color: #606266;
    }
  }
}
.systemNotification{
  padding-right: 10px;
}
.systemNotification:after {
    content: attr(data-content-after);
    background-color: red;
    display: block;
    // width: 32px;
    height: 14px;
    border-radius: 14px;
    position: absolute;
    top: 8px;
    right: 10px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    line-height: 14px;
    padding:0 5px;
}
</style>
